<template>
  <vue-good-table
    ref="table"
    :columns="columns"
    :rows="orders"
    :sort-options="{
      enabled: false
    }"
    :search-options="{
      enabled: true,
      trigger: 'enter',
      skipDiacritics: true,
      placeholder: 'Search this table',
    }"
    :pagination-options="{
      enabled: true,
      mode: 'pages',
      perPage: 10,
    }"
  >
    <div slot="table-actions">
      <button @click="exportXLSX()" class="export">
        <svg viewBox="0 0 384 512"><path d="M369.9 97.98L286.02 14.1c-9-9-21.2-14.1-33.89-14.1H47.99C21.5.1 0 21.6 0 48.09v415.92C0 490.5 21.5 512 47.99 512h288.02c26.49 0 47.99-21.5 47.99-47.99V131.97c0-12.69-5.1-24.99-14.1-33.99zM256.03 32.59c2.8.7 5.3 2.1 7.4 4.2l83.88 83.88c2.1 2.1 3.5 4.6 4.2 7.4h-95.48V32.59zm95.98 431.42c0 8.8-7.2 16-16 16H47.99c-8.8 0-16-7.2-16-16V48.09c0-8.8 7.2-16.09 16-16.09h176.04v104.07c0 13.3 10.7 23.93 24 23.93h103.98v304.01zM64 208v224c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16zm224 208h-80v-48h80v48zm0-80h-80v-48h80v48zM96 224h192v32H96v-32zm0 64h80v48H96v-48zm0 80h80v48H96v-48z"/></svg>
      </button>
    </div>
  </vue-good-table>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import { jsonToExcel, formatInventory } from '../jsonToExcel';

export default {
  name: 'RD-Inventory',
  props: {
    orders: Array
  },
  components: {
    VueGoodTable
  },
  data() {
    return {
      columns: [
        {
          label: 'Regional Director',
          field: 'accountManager',
          width: '200px',
        },
        {
          label: "Account Name",
          field: 'accountName',
          filterable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Filter'
          },
          width: '200px',
        },
        {
          label: "ARIQ Order ID",
          field: 'orderReference',
          filterable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Filter'
          }
        },
        {
          label: 'Order Placed Date',
          field: 'orderPlacedDate',
          width: '200px',
        },
        {
          label: "ARIQ Allocated Order ID",
          field: 'allocatedOrderId',
          filterable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Filter'
          }
        },
        {
          label: 'Order Allocated Date',
          field: 'orderAllocatedDate',
          width: '200px',
        },
        {
          label: "Product ID",
          field: 'productSku',
          filterable: true
        },
        {
          label: "Product Ordered",
          field: 'productName',
          filterable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Filter'
          },
          width: '300px',
        },
        {
          label: "Product Description",
          field: 'productDescription',
          width: '300px',
        },
        {
          label: "Campaign Item?",
          field: 'campaignItem'
        },
        {
          label: "Program Name",
          field: 'programName',
          width: '200px',
        },
        {
          label: "Ordered Amount",
          field: 'qtySelected'
        },
        {
          label: "Allocated Amount",
          field: 'qtyAllocated'
        },
        {
          label: 'Ship-To Name',
          field: 'shipTo',
          filterable: true,
          width: '200px',
        },
        {
          label: "Ship-To Address",
          field: 'shipToAddress',
          width: '200px',
        },
        {
          label: "Ship-To City",
          field: 'shipToCity',
          width: '100px',
        },
        {
          label: "Ship-To State",
          field: 'shipToState',
          width: '100px',
        },
        {
          label: "Ship-To Zip",
          field: 'shipToZip',
          width: '100px',
        },
        {
          label: "Receiving Contact Name",
          field: 'receivingContactName',
        },
        {
          label: "Receiving Contact Phone",
          field: 'receivingContactPhone',
          width: '200px',
        },
        {
          label: "Receiving Contact Email",
          field: 'receivingContactEmail',
          width: '200px',
        },
        {
          label: "Web Portal",
          field: 'webPortal',
        },
        {
          label: "Delivery Window",
          field: 'deliveryWindow',
        },
        {
          label: "IS A PO REQUIRED FOR DELIVERY? (YES/NO)",
          field: 'poRequired',
          filterable: true
        },
        {
          label: "PO No (if required for delivery)",
          field: 'poNum',
          filterable: true
        },
        {
          label: "PO Date for Delivery",
          field: 'poDate',
          filterable: true
        },
        {
          label: "Special Instructions",
          field: 'instructions',
          width: '300px',
        },
        {
          label: "HRMS Shipping Code",
          field: 'hrmsCode',
          filterable: true
        },
        {
          label: "HRMS Release Number",
          field: 'hrmReleaseNumber',
          filterable: true
        },
        {
          label: "Qty Pallets",
          field: 'qtyPallets'
        },
        {
          label: "Approx Wt of load",
          field: 'approxWeightLoad'
        },
        {
          label: "Transit days",
          field: 'transitDays'
        },
        {
          label: "Anticipated Pick Up / ship Date",
          field: 'anticipatedPickupDate',
          filterable: true
        },
        {
          label: "Actual Pick Up / ship Date",
          field: 'pickupDate',
          filterable: true
        },
        {
          label: "Anticipated Delivery Date",
          field: 'anticipatedDeliveryDate',
          filterable: true
        },
        {
          label: "Actual Delivery Date",
          field: 'deliveryDate',
          filterable: true
        },
        {
          label: "BOL No",
          field: 'bol',
          filterable: true
        },
        {
          label: "CHR No",
          field: 'chr',
          filterable: true
        },
        {
          label: "Delivery Type",
          field: 'deliveryType'
        },
        {
          label: "Delivery Tracking Code",
          field: 'deliveryTrackingCode'
        },
        {
          label: "Notes",
          field: 'notes',
          width: '200px',
        },
        {
          label: "Last Updated",
          field: 'lastEdited',
          width: '200px',
        },
      ]
    }
  },
  methods: {
    exportXLSX() {
      let results = this.$refs.table.filteredRows[0].children

      if (results.length === 0 ) {
        results = this.orders;
      }

      let rows = formatInventory(results);

      jsonToExcel(rows, this.columns, "Inventory Report", `inventory-report-${new Date().toISOString()}.xlsx`);
    },
  }
}
</script>